/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class AncillaryInventory extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "AncillaryInventory";
}

const servicePlugin = makeServicePlugin({
  Model: AncillaryInventory,
  service: feathersClient.service("data-services/ancillary-inventory"),
  idField: "_id",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
